/** for home page */
import bookPitch from '../assets/images/book-a-pitch.png';
import bookPitchM from '../assets/images/book-a-pitch-m.png';
import bookStudio from '../assets/images/book-a-studio.png';
import bookStudioM from '../assets/images/book-a-studio-m.png';
import gamesRoom from '../assets/images/games-room.png';
import gamesRoomM from '../assets/images/games-room-m.png';
import venueHire from '../assets/images/venue-hire.png';
import venueHireM from '../assets/images/venue-hire-m.png';

/** for booking page */
import bookingPitch from '../assets/images/pitch-hero.png';
import bookingPitchM from '../assets/images/pitch-hero-m.png';
import musicStudioHero from '../assets/images/music-studio-hero.png';
import musicStudioHeroM from '../assets/images/music-studio-hero-m.png';
import gamesRoomHero from '../assets/images/games-room-hero.jpg';
import gamesRoomHeroM from '../assets/images/games-room-hero-m.png';
import venueHireHero from '../assets/images/venue-hire-hero.png';
import venueHireHeroM from '../assets/images/venue-hire-hero-m.png';


export const _bookingTypes = [
    {
        title: 'book a pitch',
        bookingTitle: 'booking a pitch',
        type: 'pitch',
        image: {
            default: bookPitch,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: bookPitchM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: bookPitch
                }
            ]
        },
        heroImage: {
            default: bookingPitch,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: bookingPitchM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: bookingPitch
                }
            ]
        },
        description: 'Whether it’s competitive games or casual kickabouts with friends, our 3G pitch is a safe space for everyone to show their flair. Book 5-aside, 7-aside or 11-aside. We can loan you balls, bibs and corner flags.'
    },
    {
        title: 'book a music studio',
        bookingTitle: 'booking the studio',
        type: 'music_studio',
        image: {
            default: bookStudio,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: bookStudioM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: bookStudio
                }
            ]
        },
        heroImage: {
            default: musicStudioHero,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: musicStudioHeroM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: musicStudioHero
                }
            ]
        },
        description: 'Our #Merky FC HQ Studio is a professional standard, acoustically treated recording and mixing space featuring a recording booth and control room. We are fully set up to record music of any genre or to record podcasts with multiple participants. We also run regular music masterclasses for anyone who wants to learn how to produce their own music, including specific sessions for young people during the school holidays.'
    },
    {
        title: 'book gaming room',
        bookingTitle: 'booking gaming room',
        type: 'games_room',
        image: {
            default: gamesRoom,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: gamesRoomM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: gamesRoom
                }
            ]
        },
        heroImage: {
            default: gamesRoomHero,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: gamesRoomHeroM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: gamesRoomHero
                }
            ]
        },
        description: 'Play and stream on our Playstation 5, X Box and PCs. Book with friends or join one of our EA programmes to learn about the world of gaming.'
    },
    {
        title: 'venue hire',
        bookingTitle: 'venue hire',
        type: 'venue_hire',
        image: {
            default: venueHire,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: venueHireM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: venueHire
                }
            ]
        },
        heroImage: {
            default: venueHireHero,
            list: [
                {
                    media: '(max-width: 768px)',
                    srcset: venueHireHeroM
                },
                {
                    media: '(min-width: 769px)',
                    srcset: venueHireHero
                }
            ]
        },
        description: 'We have three multi functional rooms for hire at #Merky FC HQ. If you are looking for a space to hold a meeting, facilitate a workshop, lead a fitness class or any other activity please'
    }
];